import PropTypes from 'prop-types';
import { RadioButton, RadioContainer } from './';

const RadioSwitch = ({ name, checked, onChangeHandler, autoFocus, switchButtons, className }) => {
  const noBtn = (
    <RadioButton value={false} name={name} onChange={onChangeHandler} checked={!checked} autoFocus={autoFocus}>
      Nee
    </RadioButton>
  );
  const yesBtn = (
    <RadioButton value name={name} onChange={onChangeHandler} checked={checked}>
      Ja
    </RadioButton>
  );
  return (
    <RadioContainer className={className} >
      {switchButtons ? (
        <>
          {yesBtn} {noBtn}
        </>
      ) : (
        <>
          {noBtn} {yesBtn}
        </>
      )}
    </RadioContainer>
  );
};

RadioSwitch.defaultProps = {
  checked: false,
  autoFocus: false,
  switchButtons: false,
};

RadioSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onChangeHandler: PropTypes.func.isRequired,
  switchButtons: PropTypes.bool,
};

export default RadioSwitch;
